var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuTripleVerticalDotsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 11,
    viewBox: "0 0 3 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M.333 1.333a1.167 1.167 0 112.334 0 1.167 1.167 0 01-2.334 0zm0 4.167a1.167 1.167 0 112.334 0 1.167 1.167 0 01-2.334 0zm1.167 3a1.167 1.167 0 100 2.333 1.167 1.167 0 000-2.333z"
  })));
}
export default SvgMenuTripleVerticalDotsIcon;